export default "__VITE_ASSET__DBOySr$$__"